import { FC } from 'react'
import Blocks, {
  ConfigProp,
  DataProp,
  RenderersProp,
} from 'editorjs-blocks-react-renderer'
import {
  BlocksRenderer,
  type BlocksContent,
} from '@strapi/blocks-react-renderer'

import * as SC from './styled'

export type RichTextProps = {
  className?: string
  data?: DataProp
  blocks?: BlocksContent
  config?: ConfigProp | undefined
  renderers?: RenderersProp | undefined
}

const RichText: FC<RichTextProps> = ({ className, data, blocks, ...props }) => {
  if (blocks && blocks.length > 0) {
    return (
      <SC.Container className={className}>
        <BlocksRenderer content={blocks} />
      </SC.Container>
    )
  }

  return data ? (
    <SC.Container className={className}>
      <Blocks {...props} data={data} />
    </SC.Container>
  ) : null
}

export default RichText
